import {
    FilledCard,
    RichText,
    Stack,
} from '@myphx-engineering/phx-design-system';

import { PricingDisclaimer } from '../common/PricingDisclaimer';
import type { SelfPayPricingContentProps } from '../common/shared';

import { SelfPayAssistancePricingTerms } from './pricing/SelfPayAssistancePricingTerms';
import { SelfPayIncentivePricingTerms } from './pricing/SelfPayIncentivePricingTerms';
import { SelfPayPricingCardLine1 } from './pricing/SelfPayPricingCardLine1';
import { SelfPayPricingCardLine2 } from './pricing/SelfPayPricingCardLine2';
import { SelfPayPricingCardSavings } from './pricing/SelfPayPricingCardSavings';

export const SelfPayPricingContent = ({
    hasIncentiveProgram,
    medication,
    offer,
    patientPay,
    priceQualifier,
    priceType,
    savings,
    termsDisclaimer,
}: SelfPayPricingContentProps) => {
    return (
        <Stack gap="lg">
            <FilledCard
                withBorder
                color="primary"
                data-testid="pharmacy-pricing-card"
            >
                <Stack gap="xxxs">
                    <SelfPayPricingCardLine1
                        medication={medication}
                        offer={offer}
                        patientPay={patientPay}
                        priceType={priceType}
                    />
                    <SelfPayPricingCardLine2
                        medication={medication}
                        offer={offer}
                        patientPay={patientPay}
                        priceType={priceType}
                    />
                    {priceQualifier?.description ? (
                        <RichText {...priceQualifier.description} />
                    ) : (
                        <SelfPayPricingCardSavings
                            medication={medication}
                            savings={savings}
                        />
                    )}
                </Stack>
            </FilledCard>
            <Stack gap={0} data-testid="pharmacy-pricing-terms-and-conditions">
                <PricingDisclaimer
                    showDisclaimer
                    offer={offer}
                    medication={medication}
                    priceType={priceType}
                    termsDisclaimer={termsDisclaimer}
                />
                <SelfPayIncentivePricingTerms
                    hasIncentiveProgram={hasIncentiveProgram}
                    medication={medication}
                    offer={offer}
                />
                <SelfPayAssistancePricingTerms
                    hasIncentiveProgram={hasIncentiveProgram}
                    medication={medication}
                    offer={offer}
                />
            </Stack>
        </Stack>
    );
};
